import { Component } from '@angular/core';
import { ModalService } from '../../../../../../libs/utils/ng-shared-components/src/lib/services/modal.service';
import { IssueDto } from '../../../api/dtos/IssueDto';
import { ApiAdminIssue } from '../../../api/endpoints/ApiAdminIssue';

@Component({
  standalone: false,
  selector: 'mf-issue-edit',
  templateUrl: './issue-edit.component.html',
  styleUrls: ['./issue-edit.component.scss'],
})
export class IssueEditComponent {
  constructor(private _apiAdminIssue: ApiAdminIssue, private _modalService: ModalService) {
    this.issueDto = this._modalService.openData;
  }

  issueDto: IssueDto;

  async save(issueDto: IssueDto) {
    issueDto.id = this.issueDto.id;
    await this._apiAdminIssue.edit(issueDto);
    this._modalService.closeAsSuccess('El incidente se editó con éxito');
  }
}
